import React, { FC, useEffect, memo, useCallback } from 'react';

import { PlusSquareOutlined, MinusSquareOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import cn from 'classnames';

interface ExpandIconProps {
    loading?: boolean;
    expanded: boolean;
    depth: number;
    expandable: boolean;
    onExpand: (expanded: boolean) => void;
    setExpandedAll: React.Dispatch<React.SetStateAction<string[]>>;
    pathStr2?: string;
    downloaded?: boolean;
    allExpanded?: boolean;
}

const ExpandIcon: FC<ExpandIconProps> = ({ loading, expanded, depth, expandable, onExpand, setExpandedAll, pathStr2, downloaded, allExpanded }) => {
    useEffect(() => {
        if (expanded && !downloaded && !loading) {
            onExpand(expanded);
        }
    }, [downloaded, expanded, loading, onExpand]);

    const handleClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (expanded) {
            setExpandedAll((prev) => prev.filter((el) => el === pathStr2));
        }
        onExpand(!expanded);
    }, [expanded, onExpand, pathStr2, setExpandedAll]);

    const handleExpandAllClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        if (pathStr2) {
            setExpandedAll((prev) => [...new Set([...prev, pathStr2])]);
        }
        onExpand(!expanded);
    }, [expanded, onExpand, pathStr2, setExpandedAll]);

    const tooltipContent = (
        <Button
            size="small"
            onClick={handleExpandAllClick}
            style={{ 
                fontSize: 10,
                padding: '0 6px',
                height: 20,
                lineHeight: '18px'
            }}
        >
            Раскрыть всё
        </Button>
    );

    // Если «Раскрыть всё» активно — скрываем иконку и отступ полностью
    if (allExpanded) {
        return null;
    }

    return (
        <>
            <div className="table-expanded-indent" style={{ marginLeft: 25 * (depth || 0) }}></div>
            {!loading ? (
                !expanded ? (

                <div
                    className={cn('table-expanded-icon', { spaced: !expandable })}
                    style={{ display: depth === 0 && !expandable ? 'none' : 'inline-flex' }}
                >
                    {expandable ? (
                        <Tooltip
                            title={tooltipContent}
                            placement="topRight"
                            mouseEnterDelay={1}
                            color="transparent"
                            overlayInnerStyle={{ padding: 0, minHeight: 'auto', boxShadow: 'none' }}
                            align={{ offset: [30, 4] }}
                        >
                            <div onClick={handleClick}>
                                {expanded ? (
                                    <MinusSquareOutlined style={{ color: '#5b5b5b' }} />
                                ) : (
                                    <PlusSquareOutlined style={{ color: '#5b5b5b' }} />
                                )}
                            </div>
                        </Tooltip>
                    ) : null}

                </div>
                )
                    : (
                        <div
                            onClick={expandable ? handleClick : undefined}
                            className={cn('table-expanded-icon', { spaced: !expandable })}
                            style={{ display: depth === 0 && !expandable ? 'none' : 'block' }}
                        >
                            {
                                expanded ?
                                    <MinusSquareOutlined style={{ color: '#5b5b5b' }} /> :
                                    <PlusSquareOutlined style={{ color: '#5b5b5b' }} />
                            }
                        </div>
                    )
            ) : (
                <div className="table-expanded-loading">
                    <LoadingOutlined />
                </div>
            )}
        </>
    );
};

export default memo(ExpandIcon);
